export const visualColors = {
  /** Neutrale gridlijn of as (niet rood) */
  axisGuide: '#94a3b8', // slate-400
  /** Stippellijn voor aftelhulp */
  helperLine: '#60a5fa', // blue-400
  /** Let op, niet "fout" */
  attention: {
    text: 'text-amber-700',
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    stroke: '#f59e0b', // amber-500
    fill: '#fef3c7', // amber-100
  },
  /** Correct / oplossing */
  correct: {
    text: 'text-emerald-700',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
    stroke: '#10b981', // emerald-500
    fill: '#d1fae5', // emerald-100
  },
  /** Alleen voor échte fouten */
  incorrect: {
    text: 'text-red-700',
    bg: 'bg-red-50',
    border: 'border-red-200',
    stroke: '#ef4444', // red-500
    fill: '#fee2e2', // red-100
  },
  /** Neutrale didactische info */
  neutral: {
    text: 'text-indigo-700',
    bg: 'bg-indigo-50',
    border: 'border-indigo-200',
    stroke: '#6366f1', // indigo-500
    fill: '#e0e7ff', // indigo-100
  },
}
